module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.item.type === 'permalink') ? _c('a', {
    attrs: {
      "href": _vm.item.link,
      "target": _vm.item._blank ? '_blank' : ''
    }
  }, [_vm._v(_vm._s(_vm.item.title))]) : _c('router-link', {
    attrs: {
      "to": _vm.item.link
    }
  }, [_vm._v(_vm._s(_vm.item.title))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f4036b7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LinkItem.vue
// module id = 165
// module chunks = 1